module.exports = __webpack_public_path__ + "static/media/5-3.cf923def.mp3";